enum CategoryFeatureTypes {
  INTERIOR = 'interior',
  EXTERIOR = 'exterior',
  ACCESSORIES = 'accessories',
  SERVICE_PLAN = 'service_plan',
  ACCESSORY_PACK = 'accessory_pack',
}

export default CategoryFeatureTypes;
